














import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { PageNoDropDownSelector } from "../../../../base/components/system/document";
import { ScaleDropDownSelector } from "../../../../base/components/system/presentation";
import { IConfiguration } from "../../../domain/configuration";
import {
  FormatPageEditor,
  QuestionnaireFormatPageEditor,
  CommonComponentsContainer,
} from "./contents";
import { FormatStructureEditableMixin } from "./mixins";

@Component({
  components: {
    PageNoDropDownSelector,
    ScaleDropDownSelector,
    FormatPageEditor,
    QuestionnaireFormatPageEditor,
    CommonComponentsContainer,
  },
})
export default class FormatReferrer extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  $configuration!: IConfiguration;

  $refs!: {
    pageEditor: FormatPageEditor;
    commonComponents: CommonComponentsContainer;
  };

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable;
  }
}
